import styles from "./Input.module.css";

function Select({ text, name, options, handleOnChange, value }) {
  return (
    <div className={styles.itensform}>
      {text && <label htmlFor={name}>{text}</label>}
      <select
        name={name}
        id={name}
        onChange={handleOnChange}
        value={value || ''}
      >
        <option value="">Selecione uma universidade/escola</option>
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.nome}
            </option>
          ))
        ) : null}
      </select>
    </div>
  );
}

export default Select;
